import { createApp } from 'vue'
import './styles.css'
import App from './App.vue'

createApp(App).mount('#app')
